module.exports = __webpack_public_path__ + "img/logo-aequaroma.78bb08f8.jpg";